
import api from '@/services/api'
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { Group } from '@/types/Groups'
import { useToast } from 'primevue/usetoast'
import { useConfirm } from 'primevue/useconfirm'
import { PaginationBody } from '@/types/Misc'
import { useStore } from 'vuex'

export default defineComponent({
  components: {},
  setup() {
    const router = useRouter()
    const store = useStore()
    const toast = useToast()
    const confirm = useConfirm()
    const groups = ref<Group[]>([])

    const body: PaginationBody = {
      pageSize: 50,
      pageNumber: 1,
      searchValue: '',
      orderBy: '',
      descending: true
    }

    onMounted(() => {
      fetchGroups()
    })

    const tableUtilsVisible = computed(() => {
      return groups.value.filter(mod => mod.selected).length
    })
    const areGroupsSelected = computed(() => {
      return tableUtilsVisible.value ? true : false
    })

    const fetchGroups = () => {
      api.put('manager/group/filter', JSON.stringify(body)).then(res => {
        groups.value = res.data.data.list
      }).catch((err: any) => {
          toast.add({ severity: 'error', summary: err.message, life: 3000})
      })
    }

    const addGroup = () => {
      router.push('/add-group')
    }

    const deleteGroup = (group: Group) => {
      confirm.require({
        message: `Are you sure you want to delete group '${group.name}'?`,
        header: 'Warning',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          api.delete(`manager/group/${group.externalId}`).then(() => {
            toast.add({ severity: 'info', summary: `Group ${group.name} deleted`, life: 3000})
            store.dispatch('fetchGroups')
            return fetchGroups()
          }).catch((err: any) => {
            toast.add({ severity: 'error', summary: err.message, life: 3000})
          })
        }
      })
    }

    const groupDetails = (group: Group) => {
      router.push(`/group-details/${group.externalId}`)
    }

    const exportGroupResults = () => {
      toast.add({ severity: 'info', summary: 'Feature coming soon!', life: 3000})
    }

    const toggleAllGroups = () => {
      if (areGroupsSelected.value) {
        groups.value.forEach(item => item.selected = false)
      } else {
        groups.value.forEach(item => item.selected = true)
      }
    }

    return {
      groups,
      tableUtilsVisible,
      areGroupsSelected,
      addGroup,
      deleteGroup,
      groupDetails,
      exportGroupResults,
      toggleAllGroups
    }
  },
})
